import { Button, SimpleGrid, Text, useToast } from '@chakra-ui/react';
import firebase from 'firebase';
import React, { useState } from 'react';
import Lottie from 'react-lottie';
import animationData from '../../../assets/animations/mail.json';
import { Card } from '../../../components/Card';
import { PageContainer } from '../../../components/container/PageContainer';

interface VerifyEmailProps {
  currentUser: firebase.User;
}

export const VerifyEmail: React.FC<VerifyEmailProps> = ({ currentUser }) => {
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const sendEmailVerification = async () => {
    try {
      setIsLoading(true);
      await currentUser.sendEmailVerification();
      toast({
        title: 'E-Mail gesendet',
        status: 'success',
        duration: 9000,
        isClosable: true,
      });
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      toast({
        title: 'Fehler',
        description: 'Versuche es in ein paar Minuten noch einmal.',
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
    }
  };
  return (
    <PageContainer center isHeader>
      <SimpleGrid columns={[1, 1, 2]} gap={8} alignItems="center">
        <Lottie
          isClickToPauseDisabled={true}
          width={540}
          height={540}
          options={{
            loop: true,
            autoplay: true,
            animationData,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid slice',
            },
          }}
          style={{ width: '300px', height: '300px' }}
        />
        <Card
          title="Nur noch einen Schritt vom Online-Fitness entfernt!"
          animate={true}
        >
          <Text mb={3}>
            Du musst deine E-Mail nur noch bestätigen. Schaue in deinem Postfach
            nach. Falls du diese nicht findest, prüfe zur Sicherheit auch deinen
            Spam-Ordner.
          </Text>
          <Text mb={3}>
            Wenn du auf den Link in der Mail geklickt hast, lade einfach die
            Seite über den Button neu.
          </Text>
          <Button
            isFullWidth={true}
            variant="outline"
            colorScheme="brand"
            onClick={() => {
              window.location.reload();
            }}
          >
            Seite neu laden
          </Button>
          <Text py={6}>
            Falls du keine E-Mail bekommen hast, kann du sie zur Sicherheit
            erneut an {currentUser.email} senden. Klicke dafür einfach auf
            "E-Mail erneut senden".
          </Text>
          <Button
            variant="ghost"
            isFullWidth={true}
            colorScheme="brand"
            isLoading={isLoading}
            onClick={sendEmailVerification}
          >
            E-Mail erneut senden
          </Button>
        </Card>
      </SimpleGrid>
    </PageContainer>
  );
};
